import { render, staticRenderFns } from "./MakeDeta.vue?vue&type=template&id=78c83ee6&scoped=true&"
import script from "./MakeDeta.vue?vue&type=script&lang=js&"
export * from "./MakeDeta.vue?vue&type=script&lang=js&"
import style0 from "./MakeDeta.vue?vue&type=style&index=0&id=78c83ee6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c83ee6",
  null
  
)

export default component.exports